import { createRouter, createWebHistory } from 'vue-router';
import store from '../store/index';
import { warningModal } from '@/util/modalSetter';
import parkingRoutes from './modules/parking';
import prepaymentRoutes from './modules/prepayment';
import unpaidRoutes from './modules/unpaid';
import discountRoutes from './modules/discount';
import nonstopRoutes from './modules/nonstop';
import periodRoutes from './modules/period';
import webDiscountRoutes from './modules/webDiscount';
import boardRoutes from './modules/board';
import mypageRoutes from './modules/mypage';
import utilRoutes from './modules/util';
import niceRoutes from './modules/nice';

import ErrorPage from '@/pages/subpage/util/errorPage.vue';

const routes = [
  {
    path: '/',
    redirect: '/main',
  },
  {
    path: '/main',
    name: 'main',
    component: () =>
      import(
        /* webpackChunkName: "view-main-vue" */ '@/pages/mainpage/mainPage'
      ),
    meta: { category: ['메인', '메인'] },
  },
  ...parkingRoutes,
  ...prepaymentRoutes,
  ...unpaidRoutes,
  ...discountRoutes,
  ...nonstopRoutes,
  ...periodRoutes,
  ...webDiscountRoutes,
  ...boardRoutes,
  ...mypageRoutes,
  ...utilRoutes,
  ...niceRoutes,
  // Not Found Page
  {
    path: '/404',
    name: 'notFound',
    component: ErrorPage,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // 페이지 새로고침 시 스크롤을 최상단으로 이동
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const isLogin = store.state.userStore.isLogin;
  const empDiv = store.state.userStore.empDiv;
  const { empcategory } = to.meta;

  if (to.matched.some(record => record.meta.empcategory)) {
    if (!empcategory.includes(empDiv)) {
      if (empDiv === 'USR') {
        await warningModal('해당서비스는 사업자회원 전용 서비스입니다.');
        next('/main');
        return;
      }

      if (empDiv === 'BSN') {
        await warningModal('해당서비스는 일반회원 전용 서비스입니다.');
        next('/main');
        return;
      }

      if (empDiv === 'ADMIN') {
        await warningModal('관리자 계정으로는 접근 할 수 없습니다.');
        return;
      }

      await warningModal('로그인 후 이용가능한 서비스입니다.');
      next('/login');
      return;
    }
  }

  if (to.path === '/parkingrealtime') {
    await warningModal('점검중입니다.');
    return;
  }

  if (to.matched.some(record => record.meta.onlyGuest)) {
    if (isLogin) {
      return next({ path: '/main' });
    }
  }

  next();
});

// 최상단 스크롤 함수
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { top: 0 };
  }
};

// 라우터 이동시 스크롤 위치를 최상단으로 이동
router.afterEach((to, from) => {
  window.scrollTo(scrollBehavior(to, from, null));
});

export default router;
